import _ from 'lodash';

export const getRoundedFte = (fte, decimal = 1) => {
  if (fte <= 0 || !fte) return 0;
  const roundedFte = _.round(fte, decimal);
  return roundedFte || '<0.1';
};

export const getRoundedValue = (value, decimal = 1) => {
  switch (value) {
    case undefined:
      return 'N/A';
    case 0:
      return 0;
    case null:
      return '';
    default:
      return _.round(value, decimal) || '<0.1';
  }
};
